export enum ProductCollectionGroupsEnum {
    All = "0",
    Bacteria = "2",
    Bacteriophage = "5",
    CellLines = "1",
    Fungi = "3",
    Viruses = "4",
}
